import { AxiosRestApplicationClient as OnboardingAxiosRestApplicationClient } from '@g2-shared/api-client/generated/onboarding-app';
import {
  getServerErrorMessage,
  LoggingServiceAdapter,
  NotificationAdapter,
} from '@g2-shared/common';
import { generateBaseAxiosClient } from '@g2-shared/common/libs/baseAxiosClient';

/* -------------------------------- */
/*    PARTY QUESTIONNAIRE FILLED    */
/* -------------------------------- */

export const FIND_PARTY_QUESTIONNAIRE_FILLED_BY_ID = 'FIND_PARTY_QUESTIONNAIRE_FILLED_BY_ID';
export const FIND_PARTY_QUESTIONNAIRE_FILLED_BY_PARTY_CASE_AND_QUESTIONNAIRE =
  'FIND_PARTY_QUESTIONNAIRE_FILLED_BY_PARTY_CASE_AND_QUESTIONNAIRE';

export const partyQuestionnaireFilledApiDefaultConfig = {
  retry: undefined,
  // cacheTime: Infinity,
};

export const usePartyQuestionnaireFilledApiDefaultConfig = (callerName: string) => {
  const { logError } = LoggingServiceAdapter();
  const { translateAndNotifyError } = NotificationAdapter();

  return {
    ...partyQuestionnaireFilledApiDefaultConfig,
    onError: (error: unknown) => {
      translateAndNotifyError(getServerErrorMessage(error));
      logError(error, 'Error while calling party questionnaire filled api', callerName);
    },
  };
};

/* -------------- */
/*      AXIOS     */
/* -------------- */
const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const onboardingAxiosClient = new OnboardingAxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);
